export default __webpack_public_path__ + "static/success_tick-a3456665f49063a09c02fa38e70c0b0d.svg";